import { render, staticRenderFns } from "./instances-survey.vue?vue&type=template&id=75f678ac&scoped=true&"
import script from "./instances-survey.vue?vue&type=script&lang=ts&"
export * from "./instances-survey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f678ac",
  null
  
)

export default component.exports